import { useEffect, useRef } from 'react';
import { type RootState, useAppSelector } from '@/app/store';
import MessageBubble from './MessageBubble';

export default function MessageList() {
  const messages = useAppSelector((state: RootState) => state.chat.messages);
  const bottomRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <div className="flex flex-col flex-1 gap-2 p-4 overflow-y-auto">
      {messages.map((msg) => (
        <MessageBubble key={msg.id} message={msg} />
      ))}
      <div ref={bottomRef} /> {}
    </div>
  );
}
